import { render, staticRenderFns } from "./FrrButton.vue?vue&type=template&id=f1e8979e&scoped=true&"
import script from "./FrrButton.vue?vue&type=script&lang=js&"
export * from "./FrrButton.vue?vue&type=script&lang=js&"
import style0 from "./FrrButton.sass?vue&type=style&index=0&id=f1e8979e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e8979e",
  null
  
)

export default component.exports